// extracted by mini-css-extract-plugin
export default {"productGrid":"YY-z","centerLink":"ZY-z","productSection":"_Y-z","item":"aZ-z","ctaButton":"bZ-z"};